export { LicensingTable } from './LicensingTable';
export * from './LicensingTable.types';
